import { render, staticRenderFns } from "./ManualTransactionUpdate.vue?vue&type=template&id=35b05ffa"
import script from "./ManualTransactionUpdate.vue?vue&type=script&lang=js"
export * from "./ManualTransactionUpdate.vue?vue&type=script&lang=js"
import style0 from "./ManualTransactionUpdate.vue?vue&type=style&index=0&id=35b05ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports